import React, { Component } from "react";
import { getFlightsList, getPassengerList } from "../../../shared/utils";
import BaseCancellationModal from "./base-components/BaseCancellationModal";
import BaseInputRadio from "./base-components/BaseRadioInput";

export default class CancellationChangeByCiaModal extends Component {
	constructor(props) {
		super(props);
		this.passengers = getPassengerList(this.props.passengers);
		this.flights = getFlightsList(this.props.flights);
			
		let selectedFlights = [];
		let selectedPassengers = [];

		this.flights.forEach(flight => selectedFlights.push(flight.flightNumber));
		this.passengers.forEach(passenger => selectedPassengers.push({ name: passenger.name }));

		this.state = {
			formInfo: {
				passenger: selectedPassengers,
				flight: selectedFlights,
				option: 'cancel',
				typeCancel: 'changeByCia',
				budget: true,
			}
		};

		this.submitConfirmation = this.submitConfirmation.bind(this);
		this.handleChange = this.handleChange.bind(this);
	}

	submitConfirmation(event) {
		event.preventDefault();
		let formInfo = this.state.formInfo;
		this.props.callback(formInfo);
	}

	handleChange(value) {
		let formInfo = this.state.formInfo;
		formInfo.option = value;
		this.setState({ formInfo: formInfo });
	}

	render() {
		return (
			<BaseCancellationModal open={this.props.open}>
				<form onSubmit={this.submitConfirmation}>						
					<div className="modal-header-wrapper">
						<button
							onClick={() => this.props.closeModal()}
							type="button"
							className="close-button"
							alt="Fechar"
						>
							<i className="icon-close" />
						</button>

						<p className="lead">Solicitar cancelamento ou remarcação do seu voo</p>
						<p>
							Vamos entrar em contato com a companhia aérea para verificar a alteração
							de horários e a possibilidade de remarcação ou cancelamento sem a cobrança de multas.
						</p>
						<div className="row init-margin">
							<div className="col-xs-16">
								<p className="text-left">
									<strong className="text-left">
										O que você deseja vazer?
									</strong>
								</p>
							</div>
							<div className="col-sm-8">
								<BaseInputRadio
									id="cancelInput"
									name="option"
									value="cancel"
									label="Cancelar"
									checked={this.state.formInfo.option === 'cancel'}
									onChange={this.handleChange}
									/>
							</div>
							<div className="col-sm-8">
								<BaseInputRadio
									id="redialInput"
									name="option"
									value="redial"
									label="Remarcar"
									checked={this.state.formInfo.option === 'redial'}
									onChange={this.handleChange}
									/>
							</div>
						</div>
					</div>
					<div className="tingle-modal-box__content no-padding">
						<div className="row init-margin">
							<div className="col-xs-16 col-md-16">
								<button
									type="submit"
									name="submit_cancellation_change_by_cia"
									id="submit_cancellation_change_by_cia"
									className="btn btn-success btn-go no-margin-vertical"
								>
									OK
								</button>
							</div>
						</div>
					</div>
				</form>
			</BaseCancellationModal>
		);
	}
}
